import { Task, TaskLocationPayload } from '@/feature/execution-board'

import { useNetworkMutation } from '@/lib/utils/request'

export type UpdateTaskPayload = Partial<Task> & Record<string, unknown>
export type AssignOrgPayload = {
  assignedOrg: number
  predecessor?: string
}
export type UpdateLocationsPayload = {
  locations: TaskLocationPayload[]
}

export const useUpdateTaskAssignment = (taskId: string, taskAssignmentId: string) =>
  useNetworkMutation<Task, UpdateTaskPayload>({
    url: `/v1/tasks/${taskId}/assignments/${taskAssignmentId}/`,
    method: 'patch',
  })

export const useAssignOrg = (taskId: string) =>
  useNetworkMutation<{ status: number }, AssignOrgPayload>({
    url: `/v1/tasks/${taskId}/assignments/`,
    method: 'post',
  })

export const useUpdateLocations = (taskId: string) =>
  useNetworkMutation<{ status: number }, UpdateLocationsPayload>({
    url: `/v1/tasks/${taskId}/`,
    method: 'patch',
  })
